import { render } from "./LoadingData.vue?vue&type=template&id=a2546a5e&scoped=true"
import script from "./LoadingData.vue?vue&type=script&lang=js"
export * from "./LoadingData.vue?vue&type=script&lang=js"

import "./LoadingData.vue?vue&type=style&index=0&id=a2546a5e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2546a5e"]])

export default __exports__